<template>
    <div id="netImage" style="width:200px;">
        <div style="text-align:right;position:relative;top:20px;left:10px;z-index:99;">
            <el-button style="width:25px;height:25px;padding:5px;" type="danger" icon="el-icon-close" circle @click="deleteImageClick"></el-button>
        </div>
        <el-image style="width:200px;height:200px;" :src="item.image"></el-image>
    </div>
</template>

<script>
export default {
    name: 'netImage',
    props: ['item'],
    methods: {
        deleteImageClick(){
            console.log('deleteImageClick')
            this.$emit('deleteImage', this.item)
        }
    }
}
</script>

<style>

</style>